"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Services = _interopRequireDefault(require("../../Services"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spinner3 = function Spinner3(props) {
  return _react.default.createElement("div", {
    className: "sl-spinner3"
  }, _react.default.createElement("div", {
    className: "sl-loader",
    style: {
      "--size": _Services.default.getZoom(props.size || 100)
    }
  }, _react.default.createElement("div", {
    className: "sl-loader-parent"
  }, _react.default.createElement("div", {
    className: "sl-circle",
    style: {
      "--bg": props.bgColor || "#FFFFFF",
      "--border": _Services.default.rgbToPart(props.bgColor, "50") || "#FFFFFF50"
    }
  }))), props.title !== undefined ? _react.default.createElement("div", {
    className: "sl-loader-title",
    style: {
      "--cl": props.color || "#FFFFFF"
    }
  }, _react.default.createElement("span", null, props.title)) : null);
};

var _default = Spinner3;
exports.default = _default;